import { type ValidatorRule } from "rc-field-form/lib/interface"

import { placeholders } from "../../constants/placeholders"

const taxNumberRegex = /^\d{2}-\d{7}$/

const validateTaxNumber: ValidatorRule["validator"] = (rule, value: string) => {
  if (!value) {
    return Promise.resolve()
  }

  const cleanValue = value.trim()

  if (!taxNumberRegex.test(cleanValue)) {
    return Promise.reject(
      new Error(`Invalid tax number format. Use ${placeholders.taxNumber}`)
    )
  }

  return Promise.resolve()
}

const formatTaxNumber = (value: string): string => {
  const digits = value.replace(/\D/g, "")
  const limited = digits.slice(0, 9)
  if (limited.length <= 2) return limited

  return `${limited.slice(0, 2)}-${limited.slice(2)}`
}

export { taxNumberRegex, validateTaxNumber, formatTaxNumber }
